/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FeeOption } from './FeeOption';
import {
    FeeOptionFromJSON,
    FeeOptionFromJSONTyped,
    FeeOptionToJSON,
} from './FeeOption';

/**
 * A tenant-owned administered-drug entry from the fee schedule. There is no global drug list — new tenants start empty and define their own entries.
 * @export
 * @interface VitalityDrugDescription
 */
export interface VitalityDrugDescription {
    /**
     * Fee-schedule entry id. Clients send it as feeEntryId when charging.
     * @type {string}
     * @memberof VitalityDrugDescription
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VitalityDrugDescription
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof VitalityDrugDescription
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof VitalityDrugDescription
     */
    route?: string;
    /**
     * The tenant's fee options for this drug. Empty/absent = no charging offered at administration time (e.g. prepaid at booking).
     * @type {Array<FeeOption>}
     * @memberof VitalityDrugDescription
     */
    fees?: Array<FeeOption>;
    /**
     * DEPRECATED back-compat for pre-fee-schedule clients: amount of the first fee option. Use fees.
     * @type {number}
     * @memberof VitalityDrugDescription
     */
    price?: number;
    /**
     * DEPRECATED back-compat: true when the first fee option is not patient_facing (legacy "Fee for Staff" label). Use fees[].patient_facing.
     * @type {boolean}
     * @memberof VitalityDrugDescription
     */
    staff_benefit?: boolean;
}

/**
 * Check if a given object implements the VitalityDrugDescription interface.
 */
export function instanceOfVitalityDrugDescription(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VitalityDrugDescriptionFromJSON(json: any): VitalityDrugDescription {
    return VitalityDrugDescriptionFromJSONTyped(json, false);
}

export function VitalityDrugDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): VitalityDrugDescription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'fees': !exists(json, 'fees') ? undefined : ((json['fees'] as Array<any>).map(FeeOptionFromJSON)),
        'price': !exists(json, 'price') ? undefined : json['price'],
        'staff_benefit': !exists(json, 'staff_benefit') ? undefined : json['staff_benefit'],
    };
}

export function VitalityDrugDescriptionToJSON(value?: VitalityDrugDescription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'route': value.route,
        'fees': value.fees === undefined ? undefined : ((value.fees as Array<any>).map(FeeOptionToJSON)),
        'price': value.price,
        'staff_benefit': value.staff_benefit,
    };
}

